/* NOTE: This files is currently being used only in the Org Search Results page
however it should have UI parody with the main.jsx file in this repo. Eventually,
there should be one file for assetDetails.
*/
import React from "react";
import PropTypes from "prop-types";

import FontClass from "@components/asset/shared/fontClass";
import fetchCustomFields, { formatCustomFields } from "@api/v4/assets/assets";
import AssetTags from "./assetTags";
import CustomFieldsAccordion from "./customFieldsAccordion";
import AssetLinks from "./links/asset_links";
import ColorDetails from "./colorDetails";
import PersonDetails from "./personDetails";
import ShareAsset from "./shareAsset";
import TextDetails from './text';
import Attachment from "../shared/attachmentListItem";

/* NOTE : Anytime you do work in this component make sure there is parody within
the main.jsx component within this folder. The UI should be similar, however the UI
here is more limited in this file.  At some point these should become one
component. Right now they are separated beucase main.jsx  is getting the majority
of it's information from rails, whereas this component is
getting it's information from an ajax call, which does not support everything we
are currently getting from rails for the more complete details tab */

class AssetDetails extends React.Component {
  state = {
    customFields: {},
    bestLinkFor: ''
  };

  componentDidMount() {
    this.getCustomFields();
  }

  get assetBackgroundColor() {
    const backgroundColor = this.props.asset.attributes.background_color;
    return backgroundColor && backgroundColor !== "default"
      ? { background: backgroundColor }
      : { backgroundColor: "transparent" };
  }

  getCustomFields() {
    const options = {
      assetKey: this.props.asset.id,
      params: { include: 'custom_fields', fields: 'best_link_for' },
    };

    fetchCustomFields(options, () => {})
      .then((response) => { this.setState({ bestLinkFor: response.data.attributes.best_link_for }); return response; })
      .then(formatCustomFields)
      .then((formattedCustomFields) => {
        if (formattedCustomFields) {
          this.setState({ customFields: formattedCustomFields });
        }
      });
  }

  parseDate(date_string) {
    const day = date_string.substr(8, 2);
    const month = date_string.substr(5, 2);
    const year = date_string.substr(0, 4);

    return `${month}/${day}/${year}`;
  }

  backgroundColor() {
    const asset = this.props.asset;
    if (asset.type === "colors") {
      return { backgroundColor: asset.attributes.html, height: "450px" };
    }
    return undefined;
  }

  renderAttachments() {
    const { asset, attachments, activeImage, updateActiveImage } = this.props;

    return attachments.map((attachment) => (
      <Attachment
        key={attachment.id}
        isActive={attachment.id === activeImage.id}
        attachmentKey={attachment.id}
        attachment={attachment}
        updateActiveImage={updateActiveImage}
        isDownloadable={asset.attributes.is_downloadable}
      />
    ));
  }

  renderHeader() {
    const { asset, activeImage } = this.props;
    const { mimetype, url } = activeImage ? activeImage.attributes : { mimetype: null, url: null };

    if (
      mimetype
      && mimetype.indexOf("video") > -1 && activeImage.attributes
      && activeImage.attributes.url
    ) {
      const type = `video/ ${url.substr(url.lastIndexOf(".") + 1)}`;
      return (
        <div className="m-show-full-size-display">
          {type === "video/mov" ? (
            <video
              className="video-js s-expand-view"
              controls
              height="auto"
              id="advanced-video"
              src={activeImage.attributes.url}
              width="100%"
            />
          ) : (
            <video
              className="video-js s-expand-view"
              controls
              height="auto"
              id="advanced-video"
              preload="auto"
              width="100%"
            >
              <source src={activeImage.attributes.url} type={type} />
            </video>
          )}
        </div>
      );
    }

    switch (asset.type) {
      case "fonts":
        return (
          <div className="m-show-full-size-display">
            <FontClass asset={asset}>
              Aa Bb Cc Dd Ee Ff Gg Hh Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv
              Ww Xx Yy Zz 0123456789
            </FontClass>
          </div>
        );
      case "colors":
        return (
          <div
            className="m-show-full-size-display-color"
            style={this.backgroundColor()}
          />
        );
      default:
        return (
          <div
            className="m-show-full-size-display"
            style={this.assetBackgroundColor}
          >
            {activeImage ? (
              <a className="s-expand-view" href={activeImage.attributes.url} target="blank">
                <img src={activeImage.attributes.view_thumbnail_retina} alt="thumbnail" />
                <div className="view-asset-new-tab-link"><span>Open in new tab</span></div>
              </a>
            ) : <img src={asset.attributes.thumbnail_url} alt="thumbnail" />
            }
          </div>
        );
    }
  }

  renderDetailedOrGeneric() {
    const { asset } = this.props;
    const formattedDescription = asset.attributes.description
      ? asset.attributes.description.replace(/\n/g, "<br>")
      : '';

    switch (asset.type) {
      case "people":
        return (
          <PersonDetails
            bio={asset.attributes.asset_data.bio}
            email={asset.attributes.asset_data.email}
            linkedin={asset.attributes.asset_data.linkedin}
            name={asset.attributes.name}
            phoneNumber={asset.attributes.asset_data.phone_number}
            title={asset.attributes.asset_data.title}
            twitter={asset.attributes.asset_data.twitter}
          />
        );
      // TODO: implement PressDetails
      case "press":
        return (
          <div className="m-show-description">
            {asset.attributes.asset_data.url ? (
              <a href={asset.attributes.asset_data.url} target="blank">
                {asset.attributes.asset_data.url}
              </a>
            ) : (
              ""
            )}
            {asset.attributes.asset_data.published_date ? (
              <div> {asset.attributes.asset_data.published_date} </div>
            ) : (
              ""
            )}
            <div className="m-show-description s-asset-description">
              <span className="s-asset-details-title modal-label">Description</span>
              <p dangerouslySetInnerHTML={{ __html: formattedDescription }} />
            </div>
          </div>
        );
      case "colors":
        return (
          <div className="m-show-description">
            {asset.attributes.description}
          </div>
        );
      default:
        if (formattedDescription.length > 0) {
          return (
            <div className="m-show-description">
              <span className="s-asset-details-title modal-label">Description</span>
              <p dangerouslySetInnerHTML={{ __html: formattedDescription }} />
            </div>
          );
        }
    }
    return undefined;
  }

  renderCustomFields() {
    const { customFields } = this.state;

    if (customFields && Object.keys(customFields).length > 0) {
      return <CustomFieldsAccordion count={6} customFields={customFields} />;
    }
    return undefined;
  }

  renderTags() {
    if (this.props.tags.length > 0) {
      return <AssetTags tags={this.props.tags} orgSearchPage />;
    }
    return undefined;
  }

  renderUpdatedCreated() {
    const { updated_at, created_at } = this.props.asset.attributes;
    const updatedAndCreated = updated_at.length > 0 && created_at.length > 0;
    const updatedOrCreated = updated_at.length > 0 || created_at.legnth > 0;

    if (updatedOrCreated) {
      return (
        <div className="s-modal-updated-at">
          {updated_at.length > 0
            ? <React.Fragment> {t('Last updated on')} {this.parseDate(updated_at)} </React.Fragment>
            : ''
          }
          {updatedAndCreated ? <React.Fragment> &middot; </React.Fragment> : ''}
          {created_at.length > 0
            ? <React.Fragment> {t('Created on')} {this.parseDate(created_at)} </React.Fragment>
            : ''}
        </div>
      );
    }
    return undefined;
  }

  renderEmbedView() {
    const { asset, brandfolder, libraryName } = this.props;
    return (
      <div className="flex-one-third s-asset-attachments">
        <ul className="s-download-attachments-container s-attachment-conversion s-color-org-container clickable-attachments">
          {this.renderAttachments()}
          {asset.type === "colors" ? <ColorDetails assetData={asset.attributes.asset_data} /> : ''}
          {asset.type === "fonts" || asset.type === "colors" || asset.type === "external_media"
            ? <AssetLinks asset={asset} brandfolder={brandfolder} />
            : ""
          }
        </ul>
        <ul className="s-download-attachments-container actions-container">
          <li className="s-asset-action-item s-download-menu-spacing t-show-modal-download-action">
            <a
              className="noline"
              href={`${this.state.bestLinkFor}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <button
                className="button primary lg"
                type="button"
              >
                {t('View in')} {libraryName}
              </button>
            </a>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    const { asset, brandfolder, libraryName } = this.props;

    if (BFG.embedView) {
      return this.renderEmbedView();
    }

    if (asset.type === "texts") {
      return (
        <div className="s-text-details flex-two-thirds s-asset-details bf-scroll-element">
          <TextDetails
            asset={asset}
            customFields={this.state.customFields}
            formattedDescription={asset.attributes.formatted_description}
            orgSearchPage
            tags={this.props.tags}
            updatedAndCreated={this.renderUpdatedCreated()}
          />
        </div>
      );
    }
    return (
      <div className="flex-wrapper m-asset-description-show">
        <div className="flex-two-thirds s-asset-details bf-scroll-element">
          {this.renderHeader()}
          {this.renderUpdatedCreated()}
          {this.renderTags()}
          {this.renderDetailedOrGeneric()}
          {this.renderCustomFields()}
        </div>
        <div className="flex-one-third s-asset-attachments bf-scroll-element">
          <ul className="s-download-attachments-container s-attachment-conversion s-color-org-container clickable-attachments">
            {this.renderAttachments()}
            {asset.type === "colors"
              ? <ColorDetails assetData={asset.attributes.asset_data} />
              : ''
            }
            {asset.type === "fonts" || asset.type === "colors" || asset.type === "external_media"
              ? <AssetLinks asset={asset} brandfolder={brandfolder} />
              : ""
            }
          </ul>
          <ul className="s-download-attachments-container actions-container">
            {this.props.asset.attributes.is_downloadable && (
              <li className="s-asset-action-item t-show-modal-share-action">
                <ShareAsset assetKey={asset.id} />
              </li>
            )}
            <li className="s-asset-action-item s-download-menu-spacing t-show-modal-download-action">
              <a
                className="noline"
                href={`${this.state.bestLinkFor}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <button
                  className="button primary lg"
                  type="button"
                >
                  {t('View in')} {libraryName}
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

AssetDetails.propTypes = {
  asset: PropTypes.shape({
    attributes: PropTypes.shape({
      background_color: PropTypes.shape({}),
      created_at: PropTypes.string.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    id: PropTypes.string,
  }).isRequired,
  attachments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  brandfolder: PropTypes.shape({
    attributes: PropTypes.shape({}),
  }).isRequired,
  libraryName: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateActiveImage: PropTypes.func.isRequired,
};

export default AssetDetails;
